import { provideHttpClient } from '@angular/common/http';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { getAnalytics, provideAnalytics, ScreenTrackingService, UserTrackingService } from '@angular/fire/analytics';
import { FirebaseApp, initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { initializeAppCheck, provideAppCheck, ReCaptchaEnterpriseProvider } from '@angular/fire/app-check';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { provideNativeDateAdapter } from '@angular/material/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { routes } from './app.routes';
import { RoutesGuard } from './app.routes-guard';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        RoutesGuard,
        provideRouter(routes, withComponentInputBinding()),
        provideFirebaseApp(() => getFirebaseApp()),
        provideAuth(() => getAuth()),
        provideAnalytics(() => getAnalytics(getFirebaseApp())),
        ScreenTrackingService,
        UserTrackingService,
        provideAppCheck(() => {
            //console.log(`environment.reCaptchaKey: ${environment.reCaptchaKey}`);
            const provider = new ReCaptchaEnterpriseProvider(environment.reCaptchaKey);
            //console.log(`ReCaptchaEnterpriseProvider: ${provider}`);
            return initializeAppCheck(getFirebaseApp(), { provider, isTokenAutoRefreshEnabled: true });
        }),
        provideNativeDateAdapter(),
        provideHttpClient(),
        provideAnimationsAsync()]
};

let firebaseApp: FirebaseApp | undefined = undefined;

export function getFirebaseApp(): FirebaseApp {
    if (firebaseApp === undefined) {
        firebaseApp = initializeApp(environment.firebase);
    }
    return firebaseApp
}
